<template>
  <div
    :class="{
      iframePup: true,
      popupClass_green: styleType == 'typeGreen' ? true : false,
      popupClass_blue: styleType == 'typeBlue' ? true : false,
      popupClass_dark: styleType == 'typeDark' ? true : false,
      popupClass_strong: styleType == 'typeStrong' ? true : false,
    }"
  >
    <div class="closeBox" v-if="styleType == 'typeDark'" @click="close()"></div>
    <div
      class="closeBox_green"
      v-else-if="styleType == 'typeGreen'"
      @click="close()"
    ></div>
    <div
      class="closeBox_blue"
      v-else-if="styleType == 'typeBlue'"
      @click="close()"
    ></div>
    <div
      class="closeBox_blue"
      v-else-if="styleType == 'typeStrong'"
      @click="close()"
    ></div>
    <!-- <video class="videoBar" :src="videoUrlCom" autoplay loop muted controls /> -->
    <video
      v-if="!isVideo"
      id="recoderVideo"
      class="videoBar"
      x5-video-player-fullscreen="true"
      preload="none"
      playsinline="true"
      x5-video-player-typ="h5"
      x-webkit-airplay="true"
      x5-video-player-fisVideoullscreen="true"
      webkit-playsinline
      muted
      poster
      loop
      autoplay
      controls
    ></video>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import flvjs from "flv-h265.js";
import axios from "axios";

export default {
  name: "iframe-pup",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["cameraInfo"],
  data() {
    //这里存放数据
    return {
      styleType: "",
      selectRow: {},
      decs: "",
      videoBaseUrl: "http://localhost:4050", //工厂本地地址
      easyNvrProtocol: "WS-FLV",
      videoUrl: "",
      isVideo: false, //强制刷新使用
      player: null,
      recoderVideoObj: {
        recoderVideo: null,
        recorderTimer: null,
        keepRecoderAliveTimer: null,
        deviceId: null,
        nvrIP: null,
        iChannelId: null,
        recorderUrl: null,
        videoNode: null,
        easyPlayer: null,
      },
      recoderVideoObj_: {
        recoderVideo: null,
        recorderTimer: null,
        keepRecoderAliveTimer: null,
        deviceId: null,
        nvrIP: null,
        iChannelId: null,
        recorderUrl: null,
        videoNode: null,
        easyPlayer: null,
      },
      hls: null,
      iChannelId: 1,
      scale: 1,
      nvrChannel: 0,
      keepAliveTimer: "",
      recoderList: [],
      recodeDate: "",
      pickerOptionsStart: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      isLive: true,
      curChannel: "",
      recoderURL: "",
      recordeId: "",
      deviceId: "",
      serverId: "",
      flvUrl: "",
      recorderUrl: "",
      curRecodeTime: 0,
      flvTimer: null,
      flvPlayer: null,
      curVideoClose: "",
      keepRecoderAliveTimer: null,
      keepRecoderAliveTimer_: [],
      recorderTimer: null,
      isClose: false,
      deviceNo: "",
      iChannelId: "",
      hasOtherRecorder: false,
      tabVal: "",
      cameraRelationIP: {
        "172.31.64.238_401": {
          ip: "172.31.64.238",
          port: "403",
        },
        "172.15.64.111_22": {
          ip: "172.15.64.111",
          port: "17",
        },
        "172.15.64.111_23": {
          ip: "172.15.64.111",
          port: "18",
        },
        "172.15.64.111_24": {
          ip: "172.15.64.111",
          port: "16",
        },
        "172.15.64.111_25": {
          ip: "172.15.64.111",
          port: "16",
        },
        "172.15.64.111_26": {
          ip: "172.15.64.111",
          port: "16",
        },
        "172.15.64.111_27": {
          ip: "172.15.64.111",
          port: "15",
        },
        "172.15.64.111_28": {
          ip: "172.15.64.111",
          port: "15",
        },
        "172.15.64.111_29": {
          ip: "172.15.64.111",
          port: "15",
        },
      },
      axsCVR: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    // videoUrlCom() {
    //   return this.videoUrl ? this.videoUrl : require("../img/IMG_3588.mp4");
    // },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType;
    this.axsCVR = axios.create();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log("lzhxin", this.cameraInfo);
    // 调用视频接入信息
    let that = this;
    let getUrl =
      this.videoBaseUrl +
      "/api/v1/login?username=easycvr&password=5cdecdb8e87a0db1fe6e35555a870ae5";
    this.getMethodCVR(getUrl, {}).then((res) => {
      if (res.data.EasyDarwin.Header.ErrorNum == 200) {
        let body = res.data.EasyDarwin.Body;
        that.tmpToken = body["Token"];
        this.init(this.cameraInfo);
      }
    });
  },
  //方法集合
  methods: {
    close() {
      let that = this._.appContext.app;
      if (!this.type) {
        this.$popup.close(that);
      } else {
        this.$popup.close2(that);
      }
      this.flv_destroy()
      this.record_destroy(this.recoderVideoObj)
      this.record_destroy(this.recoderVideoObj_)
    },
    getMethodCVR(url, params) {
      return new Promise((resolve, reject) => {
        this.axsCVR
          .get(url, { params })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            console.error(url);
            reject(err);
          });
      });
    },
    init(row) {
      this.selectRow = row;
      this.deviceNo = row.deviceNo;
      console.log("----------------------------");
      console.log("cameraIp: " + row.cameraIp);
      console.log("cameraChannel: " + row.cameraChannel);
      this.initIntelligentRecorder();
    },
    // 初始化视频
    initIntelligentRecorder() {
      this.recoderVideoObj = {
        recoderVideo: null,
        recorderTimer: null,
        keepRecoderAliveTimer: null,
        deviceId: null,
        nvrIP: null,
        iChannelId: null,
        recorderUrl: null,
        videoNode: null,
        easyPlayer: null,
      };
      this.recoderVideoObj_ = {
        recoderVideo: null,
        recorderTimer: null,
        keepRecoderAliveTimer: null,
        deviceId: null,
        nvrIP: null,
        iChannelId: null,
        recorderUrl: null,
        videoNode: null,
        easyPlayer: null,
      };
      let relationIpList = Object.keys(this.cameraRelationIP);
      if (this.selectRow.cameraIp && this.selectRow.cameraChannel) {
        let tmpKey =
          this.selectRow.cameraIp + "_" + this.selectRow.cameraChannel;
        if ($.inArray(tmpKey, relationIpList) >= 0) {
          this.hasOtherRecorder = true;
          this.getChannelStream(
            this.selectRow.cameraIp,
            this.selectRow.cameraChannel,
            this.selectRow.startTime,
            this.selectRow.endTime
          );
          this.$forceUpdate();
          this.$nextTick(() => {
            this.getChannelStream(
              this.cameraRelationIP[tmpKey]["ip"],
              this.cameraRelationIP[tmpKey]["port"],
              this.selectRow.startTime,
              this.selectRow.endTime,
              "recoderVideo_"
            );
          });
        } else {
          this.hasOtherRecorder = false;
          this.getChannelStream(
            this.selectRow.cameraIp,
            this.selectRow.cameraChannel,
            this.selectRow.startTime,
            this.selectRow.endTime
          );
        }
      } else {
        this.hasOtherRecorder = false;
        this.getChannelStream(
          this.selectRow.cameraIp,
          this.selectRow.cameraChannel,
          this.selectRow.startTime,
          this.selectRow.endTime
        );
      }
    },
    async getChannelStream(cameraIp, cameraChannel, std, etd, videoNode) {
      let that = this;
      let ts = new Date().getTime();
      let getUrl =
        this.videoBaseUrl +
        "/api/v1/devices?menu=device_manger&start=0&limit=9999&token=" +
        this.tmpToken;
      this.getMethodCVR(getUrl, {})
        .then((res) => {
          if (res.data.EasyDarwin.Header.ErrorNum == 200) {
            let devices = res.data.EasyDarwin.Body.Devices;
            for (let i = 0; i < devices.length; i++) {
              if (
                (devices[i]["DeviceName"] === cameraIp ||
                  devices[i]["DeviceIp"] === cameraIp) &&
                devices[i]["Enable"]
              ) {
                let tmpDeviceID = devices[i]["DeviceID"];
                that.deviceId = tmpDeviceID;
                let getUrlNew =
                  this.videoBaseUrl +
                  "/api/v1/channels?start=0&limit=9999&device=" +
                  tmpDeviceID +
                  "&token=" +
                  this.tmpToken;
                this.getMethodCVR(getUrlNew, {}).then((res) => {
                  if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                    let Channels = res.data.EasyDarwin.Body.Channels;
                    that.serverId = devices[i]["ServerID"];
                    let tmpChannels = Channels;
                    for (let j = 0; j < tmpChannels.length; j++) {
                      if (
                        tmpChannels[j]["Name"] == cameraChannel ||
                        tmpChannels[j]["Name"] == cameraChannel + "01"
                      ) {
                        let tmpChannelID = tmpChannels[j]["ChannelID"];
                        that.iChannelId = tmpChannelID;
                        let tmpToken = tmpChannels[j]["Token"];

                        let recoderVideoObj = {};
                        if (videoNode) {
                          that.recoderVideoObj_.deviceId = tmpDeviceID;
                          that.recoderVideoObj_.nvrIP = cameraIp;
                          that.recoderVideoObj_.iChannelId = tmpChannelID;
                          that.recoderVideoObj_.videoNode = videoNode;
                          that.recoderVideoObj_.channelId = cameraChannel;
                          recoderVideoObj = that.recoderVideoObj_;
                        } else {
                          that.recoderVideoObj.deviceId = tmpDeviceID;
                          that.recoderVideoObj.nvrIP = cameraIp;
                          that.recoderVideoObj.iChannelId = tmpChannelID;
                          that.recoderVideoObj.videoNode = "";
                          that.recoderVideoObj.channelId = cameraChannel;
                          recoderVideoObj = that.recoderVideoObj;
                        }
                        that.date_change(
                          std,
                          etd,
                          tmpChannelID,
                          recoderVideoObj
                        );
                        break;
                      }
                    }
                  }
                });
                break;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    date_change(std, etd, channelId, recoderVideoObj) {
      this.flvPlayer ? this.flv_destroy() : "";
      this.recordChange(std, etd, channelId, recoderVideoObj);
    },
    flv_destroy() {
      if (this.flvTimer) {
        clearInterval(this.flvTimer);
      }
      if (this.keepAliveTimer) {
        clearTimeout(this.keepAliveTimer);
      }
      try {
        this.flvPlayer.pause();
        this.flvPlayer.unload();
        this.flvPlayer.detachMediaElement();
        this.flvPlayer.destroy();
        this.flvPlayer = null;
        //http://localhost:18000/api/v1/devices/stopchannelstream?stream_type=play&device=1&channel=1&url=%2Fflv%2Fhls%2Fstream_1_0.flv
        let getUrl =
          this.videoBaseUrl +
          "/api/v1/devices/stopchannelstream?stream_type=play&device=" +
          this.deviceId +
          "&channel=" +
          this.iChannelId +
          "&url=" +
          this.flvUrl;
        $.ajax({
          url: getUrl,
          success: function (res) {
            console.log(res);
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    recordChange(sTime, eTime, channelId, recoderVideoObj) {
      let that = this;
      that.record_destroy(recoderVideoObj);

      if (sTime && eTime) {
        let eTstempObj =
          new Date(eTime.replace(/-0/g, "/").replace(/-/g, "/")).getTime() +
          10 * 60 * 1000;
        let eTstemp = new Date(eTstempObj);
        let endTime =
          eTstemp.getFullYear() +
          "" +
          that.convertDoubleNum(eTstemp.getMonth() + 1) +
          "" +
          that.convertDoubleNum(eTstemp.getDate()) +
          "" +
          that.convertDoubleNum(eTstemp.getHours()) +
          "" +
          that.convertDoubleNum(eTstemp.getMinutes()) +
          "" +
          that.convertDoubleNum(eTstemp.getSeconds());

        let sTstemp = new Date(sTime.replace(/-0/g, "/").replace(/-/g, "/"));
        let selTime =
          sTstemp.getFullYear() +
          "" +
          that.convertDoubleNum(sTstemp.getMonth() + 1) +
          "" +
          that.convertDoubleNum(sTstemp.getDate()) +
          "" +
          that.convertDoubleNum(sTstemp.getHours()) +
          "" +
          that.convertDoubleNum(sTstemp.getMinutes()) +
          "" +
          that.convertDoubleNum(sTstemp.getSeconds());
        let tmpArgs =
          "file=NVR&stime=" +
          selTime +
          "&etime=" +
          endTime +
          "&channel=" +
          channelId +
          "&ServerID=" +
          that.serverId +
          "&protocol=flv&token=" +
          that.tmpToken;
        let getUrl =
          this.videoBaseUrl + "/api/v1/devices/record/playback?" + tmpArgs;
        axios
          .get(getUrl, {
            params: {},
          })
          .then((res) => {
            if (res.data.EasyDarwin.Header.ErrorNum == 200) {
              let recorderUrl = res.data.EasyDarwin.Body.URL;
              recoderVideoObj.recorderUrl = recorderUrl;
              that.initRecode(recorderUrl, tmpArgs, "", "", recoderVideoObj);
            }
          });
      }
    },
    record_destroy(recoderVideoObj) {
      if (this.webRtcServer && this.webRtcServer.disconnect) {
        this.webRtcServer.disconnect();
      }
      if (recoderVideoObj.recorderTimer) {
        clearInterval(recoderVideoObj.recorderTimer);
      }
      if (recoderVideoObj.keepRecoderAliveTimer) {
        clearTimeout(recoderVideoObj.keepRecoderAliveTimer);
      }
      try {
        recoderVideoObj.recoderVideo.pause();
        recoderVideoObj.recoderVideo.unload();
        recoderVideoObj.recoderVideo.detachMediaElement();
        recoderVideoObj.recoderVideo.destroy();
        recoderVideoObj.recoderVideo = null;

        //http://localhost:18000/api/v1/devices/stopchannelstream?stream_type=playback&device=1&channel=1&url=%2Fflv%2Fhls%2Fstream_localhost_33_ch0001_04010000823000000_202195125727_202195131540.flv

        let getUrl =
          this.videoBaseUrl +
          "/api/v1/devices/stopchannelstream?stream_type=playback&device=" +
          recoderVideoObj.deviceId +
          "&channel=" +
          recoderVideoObj.iChannelId +
          "&token=" +
          this.tmpToken +
          "&url=" +
          recoderVideoObj.recorderUrl;
        $.ajax({
          url: getUrl,
          success: function (res) {
            console.log(res);
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    convertDoubleNum(val) {
      if (val < 10) {
        return "0" + val;
      } else {
        return "" + val;
      }
    },
    initRecode(url, args, deltaSec, deltaTime, recoderVideoObj) {
      let that = this;
      this.recorderUrl = url;
      if (flvjs.isSupported()) {
        let videoBaseUrl = this.videoBaseUrl;
        if (this.easyNvrProtocol === "WS-FLV") {
          videoBaseUrl = videoBaseUrl.replace(/http:\/\//g, "ws://");
        }

        that.initRecodeDetail(url, args, deltaSec, deltaTime, recoderVideoObj);
        recoderVideoObj.recoderVideo.on(
          flvjs.Events.ERROR,
          (errorType, errDetail, errorInfo) => {
            console.log("errorType:", errorType);
            console.log("errorDetail:", errorDetail);
            console.log("errorInfo:", errorInfo);
            if (recoderVideoObj.recoderVideo) {
              recoderVideoObj.recoderVideo.pause();
              recoderVideoObj.recoderVideo.unload();
              recoderVideoObj.recoderVideo.detachMediaElement();
              recoderVideoObj.recoderVideo.destroy();
              recoderVideoObj.recoderVideo = null;
              that.initRecodeDetail(
                url,
                args,
                deltaSec,
                deltaTime,
                recoderVideoObj
              );
            }
          }
        );
      }
    },
    initRecodeDetail(url, args, deltaSec, deltaTime, recoderVideoObj) {
      let that = this;
      let recoderVideoEl = recoderVideoObj.videoNode
        ? document.getElementById(recoderVideoObj.videoNode)
        : document.getElementById("recoderVideo");
      if (recoderVideoEl) {
        recoderVideoObj.recoderVideo = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true,
            hasAudio: false,
            //url: "ws://localhost:10800/ws/flv/hls/stream_" + channel + ".flv", //<==自行修改
            url: this.videoBaseUrl + url,
            //duration: deltaTime * 1000,
            currentTime: 0,
          },
          {
            autoCleanupSourceBuffer: true, //对SourceBuffer进行自动清理
            autoCleanupMaxBackwardDuration: 12, //    当向后缓冲区持续时间超过此值（以秒为单位）时，请对SourceBuffer进行自动清理
            autoCleanupMinBackwardDuration: 8, //指示进行自动清除时为反向缓冲区保留的持续时间（以秒为单位）。
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            isLive: true,
            lazyLoad: false,
          }
        );
        let recoderVideo = recoderVideoObj.recoderVideo;
        recoderVideo.attachMediaElement(recoderVideoEl);
        recoderVideo.load(); //加载

        recoderVideo.play();

        recoderVideo.on("statistics_info", function (res) {
          if (recoderVideoObj.lastDecodedFrame == 0) {
            recoderVideoObj.lastDecodedFrame = res.decodedFrames;
            return;
          }
        //   console.log(recoderVideo.buffered && recoderVideo.buffered.end(0));
          if (recoderVideoObj.lastDecodedFrame != res.decodedFrames) {
            recoderVideoObj.lastDecodedFrame = res.decodedFrames;
          } else {
            recoderVideoObj.lastDecodedFrame = 0;
            if (recoderVideo) {
              recoderVideo.pause();
              recoderVideo.unload();
              recoderVideo.detachMediaElement();
              recoderVideo.destroy();
              recoderVideo = null;
              that.initRecodeDetail(
                url,
                args,
                deltaSec,
                deltaTime,
                recoderVideoObj
              );
            }
          }
        });

        if (recoderVideoObj.recorderTimer) {
          clearInterval(recoderVideoObj.recorderTimer);
        }
        recoderVideoObj.recorderTimer = setInterval(() => {
          if (!recoderVideo.buffered.length) {
            return;
          }
          let end = recoderVideo.buffered && recoderVideo.buffered.end(0);
          let diff = end - recoderVideo.currentTime;
          if (diff >= 1.5) {
            recoderVideo.currentTime =
              recoderVideo.buffered && recoderVideo.buffered.end(0); //end - 1;
          }
        }, 2000);
      }

      recoderVideoObj.rtcPlayer = recoderVideoObj.videoNode
        ? document.getElementById("rtc_recoderVideo_")
        : document.getElementById("rtc_recoderVideo");
      if (recoderVideoObj.rtcPlayer) {
        if (!recoderVideoObj.videoNode) {
          if (this.webRtcServer && this.webRtcServer.disconnect) {
            this.webRtcServer.disconnect();
          }
          this.webRtcServer = new WebRtcStreamer(
            "rtc_recoderVideo",
            "http://10.100.105.15:8000"
          );
          let tmpTime = args.split("&")[2].substr(6);
          let tmpYear = tmpTime.substr(0, 4);
          let tmpMonth = tmpTime.substr(4, 2);
          let tmpDate = tmpTime.substr(6, 2);
          let tmpHour = tmpTime.substr(8, 2);
          let tmpMinute = tmpTime.substr(10, 2);
          let tmpSecond = tmpTime.substr(12, 2);
          let tmpBegin =
            tmpYear +
            "" +
            tmpMonth +
            "" +
            tmpDate +
            "T" +
            tmpHour +
            "" +
            tmpMinute +
            "" +
            tmpSecond +
            "Z";
          let tmpEnd =
            tmpYear +
            "" +
            tmpMonth +
            "" +
            tmpDate +
            "T" +
            (tmpHour + 1) +
            "" +
            tmpMinute +
            "" +
            tmpSecond +
            "Z";
          let rtsp =
            "rtsp://admin:bme12345@" +
            recoderVideoObj.nvrIP +
            ":554/Streaming/tracks/" +
            recoderVideoObj.channelId +
            "/starttime=" +
            tmpBegin;
          this.webRtcServer.connect(rtsp);
        }
      }

      recoderVideoObj.easyPlayer = recoderVideoObj.videoNode
        ? document.getElementById("Easy_recoderVideo_")
        : document.getElementById("Easy_recoderVideo");
      if (recoderVideoObj.easyPlayer) {
        recoderVideoObj.easyPlayer.setAttribute("decode-wasm", false);
        recoderVideoObj.easyPlayer.setAttribute("live", true);
        recoderVideoObj.easyPlayer.setAttribute(
          "video-url",
          "http://localhost:18000" + url
        );
      }

      if (recoderVideoObj.keepRecoderAliveTimer) {
        clearTimeout(recoderVideoObj.keepRecoderAliveTimer);
      }
      recoderVideoObj.keepRecoderAliveTimer = setTimeout(function () {
        that.keepRecoderAlive(url, args, recoderVideoObj);
      }, 5 * 1000);
    },
     keepRecoderAlive(url, args, recoderVideoObj) {
          let that = this
          let ts = new Date().getTime()
          let getUrl = this.videoBaseUrl + '/api/v1/devices/record/playback?' + args + '&url=' + url.replace(/\//g, '%2F')
          axios.get(getUrl, {
            params: {}
          })

          if (recoderVideoObj.keepRecoderAliveTimer) {
            clearTimeout(recoderVideoObj.keepRecoderAliveTimer)
          }

          recoderVideoObj.keepRecoderAliveTimer = setTimeout(function () {
            that.keepRecoderAlive(url, args, recoderVideoObj)
          }, 5 * 1000)
        },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.popupClass_green {
  background: rgb(14, 82, 76);
}
.popupClass_dark {
  background: rgb(0, 0, 0);
}
.popupClass_blue {
  background: rgb(8, 25, 57);
}
.popupClass_strong {
  background: radial-gradient(rgb(26 88 169), rgb(1 19 41 / 70%));
}
.iframePup {
  width: 1734px;
  height: 950px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  iframe {
    width: 100%;
    height: 100%;
  }
  .videoBar {
    position: relative;
    width: 80%;
    height: 80%;
    margin: 5% 10%;
  }
  .closeBox {
    position: absolute;
    top: 0px;
    right: 4px;
    width: 122px;
    height: 38px;
    background-image: url("../img/close.png");
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background-image: url("../img/close_active.png");
    }
  }
  .closeBox_green {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 60px;
    height: 36px;
    background-image: url("../img/close_green.png");
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background-image: url("../img/close_green_active.png");
    }
  }
  .closeBox_blue {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 60px;
    height: 60px;
    background-image: url("/static/img/popupImg/close_default_blue.png");
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background-image: url("/static/img/popupImg/close_blue.png");
    }
  }
}
</style>